export default __webpack_public_path__ + "static/media/party-eric.5efb0875.jpg";